/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";
import { header } from "../../../../components/api/Header";
import { getEnv } from "../../../../lib/env";

function SuvOmborlar({ date }) {
  const [data, setData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/dashboard/suvomborlar?date=" +
            date,
          header()
        );

        if (res) {
          setData(res.data);
        }
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan aloqa yo'q!");
      }
    };
    fetchData();
  }, [date]);

  return (
    <div className='card statistic-card card4 pb-0'>
      <h4 className='title mb-0 text-center'>Suv omborlari</h4>
      <ul className='half-pie'>
        <li>
          <h4 className='s-title'>
            Kelishi (
            <span className='lower'>
              m<sup>3</sup>/s
            </span>
            )
          </h4>

          <div className='_progress'>
            <div className='barOverflow'>
              <div
                className='_bar'
                style={{
                  borderBottomColor: "rgb(59 130 246)",
                  borderRightColor: "rgb(59 130 246)",
                  transform: "rotate(117deg)",
                }}></div>
            </div>

            <div className='data-number'>
              {data ? fix(data["kelishi"]) : "-"}
              <span>20</span>
            </div>
          </div>
        </li>

        <li>
          <h4 className='s-title'>
            Chiqishi{" "}
            <span className='lower'>
              (m<sup>3</sup>/s)
            </span>
          </h4>

          <div className='_progress'>
            <div className='barOverflow'>
              <div
                className='_bar'
                style={{
                  borderBottomColor: "rgb(27, 203, 128)",
                  borderRightColor: "rgb(27, 203, 128)",
                  transform: "rotate(117deg)",
                }}></div>
            </div>

            <div className='data-number'>
              {data ? fix(data["chiqishi"]) : "-"}
              <span>40</span>
            </div>
          </div>
        </li>

        <li>
          <div className='total-data'>
            <div>
              <h4>{data ? fix(data["hajmi"]) : "-"}</h4>
              <p className='lower'>
                Hajmi (mln.m<sup>3</sup>)
              </p>

              <span
                className='vertical-line'
                style={{ backgroundColor: "#0077FF" }}></span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default SuvOmborlar;

const fix = (v, b = 1) => {
  if (!v || typeof v == "undefined" || v === "-") {
    return "-";
  } else {
    return (parseFloat(v) / b).toFixed(1);
  }
};
